export const theme = (): {
  warningColor: string
  alt5Color: string
  positiveColor: string
  accentColor: string
  primaryColor: string
  alt2Color: string
  semiMutedColor: string
  alt3Color: string
  alt4Color: string
  alt1Color: string
  negativeColor: string
  secondaryColor: string
  alt6Color: string
} => {
  const rootStyle = getComputedStyle(document.body)

  return <const>{
    primaryColor: rootStyle.getPropertyValue("--primary-color").trim(),
    secondaryColor: rootStyle.getPropertyValue("--secondary-color").trim(),
    accentColor: rootStyle.getPropertyValue("--accent-color").trim(),
    warningColor: rootStyle.getPropertyValue("--warning-color").trim(),
    negativeColor: rootStyle.getPropertyValue("--negative-color").trim(),
    positiveColor: rootStyle.getPropertyValue("--positive-color").trim(),
    semiMutedColor: rootStyle.getPropertyValue("--semi-muted-color").trim(),
    alt1Color: rootStyle.getPropertyValue("--alt-1-color").trim(),
    alt2Color: rootStyle.getPropertyValue("--alt-2-color").trim(),
    alt3Color: rootStyle.getPropertyValue("--alt-3-color").trim(),
    alt4Color: rootStyle.getPropertyValue("--alt-4-color").trim(),
    alt5Color: rootStyle.getPropertyValue("--alt-5-color").trim(),
    alt6Color: rootStyle.getPropertyValue("--alt-6-color").trim(),
  }
}
